module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1206.9a195c2c.png";